export var name = 'gallery';
export var supports = function (env) {
    return env.isInToutiaoProduct && !env.isInMobile;
};
